import React, { useEffect, useRef, useState } from 'react';

import './index.module.less';

import { Api } from '@apis/client';
import Http from '@helpers/Http';
import Filter from '@helpers/Filter';

import NavBar from '@components/NavBar';
// import CommonBtn from '@components/CommonBtn';
// import Toast from '@widgets/Toast';
import imgQrcodeSplit from './images/img_qrcode_split.png';
import avatarIconUrl from '@images/avatar_normal.png';

const DeviceQrcodeInfo = () => {
  const [bindInfo, setBindInfo] = useState(null);
  const params = useRef(Filter.urlParams(window.location.search));

  const getInfo = async () => {
    const { data } = await Http.post(Api.GetDeviceDetailInfo, {
      snCode: params.current.sncode,
      company: 'lingge',
    });
    setBindInfo(data);
  };

  // const downloadImage = () => {
  //   console.log(bindInfo.snCodeUrl, 'bindInfo.snCodeUrl')
  //   const a = document.createElement('a'); //创建一个 a 标签
  //   a.href = bindInfo.snCodeUrl;
  //   a.download = Date.now() + '.jpeg';
  //   a.id = 'touchLink';
  //   document.body.appendChild(a);

  //   const evt = document.createEvent('MouseEvent')
  //   evt.initEvent('click', false, false)
  //   document.getElementById('touchLink').dispatchEvent(evt)
  //   Toast.show({
  //     title: '保存成功',
  //     type: 'strip'
  //   })
  // }

  useEffect(() => {
    getInfo();
  }, []);
  return (
    <div className="flex container" styleName="container">
      <NavBar title="设备二维码" />
      <div className="flex" styleName="card-wrapper">
        <div styleName="card">
          <div className="flex" styleName="card-header">
            <img
              styleName="card-header-img"
              alt=""
              src={bindInfo?.headImageUrl || avatarIconUrl}
            />
            <div className="flex" styleName="card-header-info">
              <div styleName="card-header-info-name">
                {bindInfo
                  ? bindInfo?.userName || '学生证' + bindInfo?.snCode
                  : ''}
                的电子学生证
              </div>
              <div styleName="card-header-info-desc">
                IMEI：{bindInfo?.snCode || ''}
              </div>
            </div>
          </div>

          <div styleName="card-img">
            <img src={imgQrcodeSplit} alt="" />
          </div>
          <div styleName="card-qrcode">
            <img src={bindInfo?.snCodeUrl || ''} alt="" />
          </div>
          <div styleName="card-desc">希沃魔方APP扫一扫添加设备</div>
        </div>
      </div>
      {/* <CommonBtn
        type="fixed"
        btnText="保存到相册"
        onConfirm={downloadImage}
      /> */}
    </div>
  );
};

export default DeviceQrcodeInfo;
